module.exports = __webpack_public_path__ + "files/b83b0fa6fff7f3e58df9523023f14df5.png";